import { AutogenModelCarrierVehicleLookup, AutogenRowCarrierVehicleLookup } from "./autogen/AutogenModelCarrierVehicleLookup";

export class ModelCarrierVehicleLookup extends AutogenModelCarrierVehicleLookup<RowCarrierVehicleLookup> {
    constructor() {
        super(RowCarrierVehicleLookup);
    }
}

export class RowCarrierVehicleLookup extends AutogenRowCarrierVehicleLookup {
}